import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SharedProgrammingService } from '../../common/services/shared-programming.service';
import { QuickstartProgrammingService } from './../services/quickstart-programming.service';
import { ScheduleProgrammingService } from './services/schedule.service';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-schedule-quickstart',
  templateUrl: './schedule-quickstart.component.html',
  styleUrls: ['./schedule-quickstart.component.less']
})
export class ScheduleQuickstartComponent extends BaseRoutingComponent implements OnInit {

  constructor(
    protected router: Router,
    protected store: Store<any>,
    private schedules: ScheduleProgrammingService,
    private shared: SharedProgrammingService,
    private quickstarts: QuickstartProgrammingService
  ) {
    super();
  }

  ngOnInit() {
    this.shared.clearError();
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/schedule-quickstart.component.ts